export const tutorialDataTestIds = {
  primaryButton: 'primary-button',
  tutorialPagination: 'tutorial-pagination',
  closeButton: 'close-button',
  backButton: 'back-button',
  activeDot: 'active-dot',
  inactiveDot: 'inactive-dot',
  robotInFrameIcon: 'robot-in-frame-icon',
}

export const mockTutorialStore = {
  isTeacher: true,
  kcInfo: { roles: [] },
  hubPrograms: {
    CKLA: ['K', '5', '3', '4', '1', '2'],
    CKLA3: ['K', '5', '3', '4', '1', '2'],
    CAMINOS: ['K', '5', '3', '4', '1', '2'],
    TEXAS_SLAR: ['K', '5', '3', '4', '1', '2'],
    TEXAS_ELAR: ['K', '5', '3', '4', '1', '2'],
    allApps: ['K', '5', '3', '4', '1', '2'],
  },
  grade: '1',
}
